import React, { useRef, useEffect } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
// We'll trust the global dark mode or specific overrides, but importing the dark theme is good practice if we want it dark by default
import "flatpickr/dist/themes/dark.css";

const FilterDatePicker = ({ value, onChange, placeholder = "Select Date" }) => {
    const pickerRef = useRef(null);

    useEffect(() => {
        if (pickerRef.current) {
            const fp = flatpickr(pickerRef.current, {
                defaultDate: value,
                onChange: ([selectedDate]) => {
                    // Start date usually needs YYYY-MM-DD
                    const dateStr = selectedDate ? selectedDate.toISOString().split('T')[0] : "";
                    onChange(dateStr);
                },
                dateFormat: "Y-m-d",
                disableMobile: "true",
                // Customizing classes to match the dark theme better if needed
                static: true, // helpful for positioning in some layouts
                theme: "dark"
            });

            return () => {
                fp.destroy();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onChange, value]);

    return (
        <div className="relative">
            <input
                ref={pickerRef}
                type="text"
                placeholder={placeholder}
                defaultValue={value}
                className="w-full min-w-[140px] rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 outline-none transition-all placeholder:text-gray-400 hover:border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary dark:border-gray-700 dark:bg-[#1e293b] dark:text-gray-200 dark:placeholder:text-gray-500 dark:hover:border-gray-600"
            />
        </div>
    );
};

export default FilterDatePicker;
